import { cloneElement, FC, isValidElement, PropsWithChildren, useEffect } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { WixConnection } from './components/wix-connection';
import { SiteSessionWrapper } from './modules/sites/site-session-wrapper';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import { Bootstrap } from 'src/redesign/app';
import { MainLayout } from 'src/redesign/layouts';
import { usePostHog } from 'posthog-js/react';
import { isEmpty } from 'lodash';
import { Header } from 'src/redesign/features/Header';
import { Tabs } from 'src/redesign/features/Tabs';
import { AuthRouter } from 'src/features/AuthRouter';
import { PublicRouter } from 'src/features/PublicRouter';
import styles from './App.module.scss';
import './styles.scss';
import { useAppSelector } from 'src/hooks';
import {
  accountSelector,
  lastAccessedSiteIdSelector,
} from 'src/redesign/features/Account/store/selectors';
import { Modals } from 'src/redesign/features/Modals';
import { globalReloadingSelectors } from 'src/redesign/shared/store/selectors';
import { Loader } from 'wix-style-react';
import Intercom from '@intercom/messenger-js-sdk';
import { ToastNotifications } from 'src/redesign/features/Toast';
import { Dialog } from 'primereact/dialog';
import { TicketPacksBanner } from 'src/components/TicketPacksBanner';
import { ConfirmDialog } from 'primereact/confirmdialog';
// import { getSelectedSiteDataSelector } from 'src/redesign/features/SelectedSite/store/selectors';
// import { selectSettings } from 'src/features/settings-slice';

export const isPublicRoute = () => {
  const path = window.location.href;
  return (
    path.includes('/auth/') ||
    path.includes('/new-event/') ||
    path.includes('/email-verification') ||
    path.includes('/self-checkin') ||
    path.includes('/order-frame') ||
    path.includes('/invitations')
  );
};
export const App = () => {
  const account = useAppSelector(accountSelector);
  const posthog = usePostHog();
  const globalReloading = useAppSelector(globalReloadingSelectors);
  // const site = useAppSelector(getSelectedSiteDataSelector);
  // const settings = useAppSelector(selectSettings);
  const lastAccessedSiteId = useAppSelector(lastAccessedSiteIdSelector);

  useEffect(() => {
    const path = window.location.href;

    // Check if user is on the main dashboard URL (not a white label domain)
    const isOnDashboardUrl = process.env.DASHBOARD_CLIENT_URL
      ? window.location.origin === new URL(process.env.DASHBOARD_CLIENT_URL).origin
      : true;

    const shouldHideIntercom =
      !isOnDashboardUrl ||
      path.includes('/new-event/') ||
      path.includes('/self-checkin') ||
      path.includes('/attendee-dashboard');

    if (!shouldHideIntercom) {
      const intercomConfig: Record<string, any> = {
        app_id: 'm51ut11q',
      };

      if (!isEmpty(account)) {
        intercomConfig.user_id = account.id;
        intercomConfig.name = account.first_name
          ? `${account.first_name} ${account.last_name}`
          : account.email;
        intercomConfig.email = account.email;
        intercomConfig.created_at = account.created_at;
        intercomConfig.user_hash = account.intercom_hash;

        // // Add site and settings attributes
        // if (site) {
        //   intercomConfig.site_type = site.type;
        //   intercomConfig.site_id = site.id;
        // }
        // if (lastAccessedSiteId) {
        //   intercomConfig.last_accessed_site_id = lastAccessedSiteId;
        // }
        // if (settings?.plan) {
        //   intercomConfig.plan = settings.plan;
        // }

        posthog?.identify(account.email, {
          email: account.email,
        });
      }

      Intercom(intercomConfig);
    }
  }, [account, posthog, lastAccessedSiteId]);

  if (
    process.env.NODE_ENV === 'production' &&
    window.brand === 'wix' &&
    !account?.has_app_updated
  ) {
    return <WixConnection />;
  }

  return (
    <Bootstrap>
      <Dialog
        header="Account Disabled"
        visible={account?.is_disabled === true}
        closable={false}
        draggable={false}
        resizable={false}
        style={{ width: '450px' }}
        modal
      >
        <div style={{ padding: '20px 0' }}>
          <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
            Your account has been disabled due to being against our terms.
          </p>
          <p style={{ lineHeight: '1.6' }}>
            Please contact support at{' '}
            <a href="mailto:support@ticketspotapp.com" style={{ color: '#007bff' }}>
              support@ticketspotapp.com
            </a>{' '}
            if this is incorrect.
          </p>
        </div>
      </Dialog>
      <ConfirmDialog draggable={false} />
      {account && !isPublicRoute() ? (
        <>
          <TicketPacksBanner />
          <Header />
          <Tabs />
          <MainLayout>{globalReloading ? <Loader size="small" /> : <AuthRouter />}</MainLayout>
          <Modals />
          <ToastNotifications />
        </>
      ) : (
        <div className={styles.publicPageWrapper}>
          <PublicRouter />
          <ToastNotifications />
        </div>
      )}
    </Bootstrap>
  );

  // return (
  //   <div className="App">
  //     {window.brand === 'wix' && account.newsletter_opt_in === null && (
  //       <NewsletterOptIn account={account} />
  //     )}
  //     {/* {account.display_review_offer === null && <LeaveReview account={account} />} */}

  //   </div>
  // );
};

export const SiteWrapper: FC<PropsWithChildren<RouteChildrenProps & { noAuth?: boolean }>> = (
  props,
) => {
  const { children, match, noAuth } = props;
  const params = match.params as { site_id?: string };
  return (
    <SiteSessionWrapper siteId={params?.site_id} noAuth={noAuth}>
      {isValidElement(children) && cloneElement(children, { ...props })}
    </SiteSessionWrapper>
  );
};
